import { render } from "./ReactivateModal.vue?vue&type=template&id=252ddeb2&scoped=true"
import script from "./ReactivateModal.vue?vue&type=script&lang=js"
export * from "./ReactivateModal.vue?vue&type=script&lang=js"

import "./ReactivateModal.vue?vue&type=style&index=0&id=252ddeb2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-252ddeb2"],['__file',"src/components/ReactivateModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "252ddeb2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('252ddeb2', __exports__)) {
    api.reload('252ddeb2', __exports__)
  }
  
  module.hot.accept("./ReactivateModal.vue?vue&type=template&id=252ddeb2&scoped=true", () => {
    api.rerender('252ddeb2', render)
  })

}


export default __exports__